import api from '../../shared/AxiosConfig';

const getDashboard = () =>
    api.get('/dashboard');

export const dashboardApi = {
    getDashboard,
};
